module.exports = __webpack_public_path__ + "static/img/PSD63-S.408cbef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/PSD63-S.png
// module id = gFTm
// module chunks = 1